<template>
  <div class="main">
    <Navbar />
    <section class="main-hero">
      <p class="main-title">Whop member login</p>
      <p class="main-subtitle">
        Sign in with your Whop account to access PDF lessons and video lessons.
      </p>

      <article class="message is-danger" v-if="errorMessage">
        <div class="message-header">
          <p>Unable to sign in</p>
          <button
            @click="errorMessage = ''"
            class="delete"
            aria-label="delete"
          ></button>
        </div>
        <div class="message-body">
          {{ errorMessage }}
          <p v-if="storefrontUrl" class="storefront">
            <a :href="storefrontUrl" target="_blank" rel="noopener noreferrer"
              >Get access on Whop</a
            >
          </p>
        </div>
      </article>

      <div class="buttons">
        <button
          @click="startLogin"
          class="submit button"
          :class="{ 'is-loading': loading }"
          :disabled="loading"
        >
          Continue with Whop
        </button>
        <router-link :to="{ name: 'Login' }" class="alt-link"
          >Email login</router-link
        >
      </div>
    </section>
    <div class="main-footer">
      <a @click="disclaimer = true">disclaimer</a>
    </div>
    <DisclaimerModal :active="disclaimer" @close="disclaimer = false" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import DisclaimerModal from "@/components/DisclaimerModal";
import WhopAuthService from "@/services/WhopAuthService";

export default {
  name: "LoginWhop",
  components: {
    Navbar,
    DisclaimerModal,
  },
  data() {
    return {
      loading: false,
      errorMessage: "",
      storefrontUrl: "",
      disclaimer: false,
    };
  },
  methods: {
    async startLogin() {
      this.loading = true;
      this.errorMessage = "";
      this.storefrontUrl = "";
      try {
        const res = await WhopAuthService.startWhopLogin();
        const authorizeUrl = res?.data?.authorizeUrl;
        if (!res?.success || !authorizeUrl) {
          this.errorMessage =
            "Something went wrong. Please try again in a moment.";
          this.loading = false;
          return;
        }
        window.location.assign(authorizeUrl);
      } catch (e) {
        const status = e?.response?.status;
        this.errorMessage =
          status === 429
            ? "Too many attempts. Please wait a moment and try again."
            : "Something went wrong. Please try again in a moment.";
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
  font-family: "Work Sans", sans-serif;
  background: linear-gradient(
    180deg,
    var(--background-color-gradient-secondary) 0%,
    var(--background-color-gradient-tertiary) 100%
  );
  &:before {
    content: " ";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    background-image: url("~@/assets/ocean-bg.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
.main-hero {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  .main-title {
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 300;
    font-size: 32px;
    line-height: 38px;
    text-align: center;
    color: white;
    margin-bottom: 12px;
  }
  .main-subtitle {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #e5e5e5;
    max-width: 420px;
    margin-bottom: 28px;
  }
}
.main-footer {
  display: flex;
  justify-content: center;
  padding-bottom: 32px;
  z-index: 2;
  a {
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    letter-spacing: 0.1em;
    text-decoration-line: underline;
    color: #ffffff;
  }
}
.buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  z-index: 1;
  button.submit {
    cursor: pointer;
    border: none;
    padding: 10px 22px;
    background: var(--submit-button);
    border-radius: 5px;
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    &:disabled {
      cursor: not-allowed;
    }
  }
  .alt-link {
    font-family: "Work Sans";
    font-weight: 300;
    font-size: 12px;
    text-decoration-line: underline;
    color: #ffffff;
  }
}
.message {
  max-width: 420px;
  margin-bottom: 20px;
  z-index: 1;
}
.storefront {
  margin-top: 8px;
}
</style>
